import React from "react";
import { useTranslation } from "react-i18next";
import { getTranslatedLabel } from "../../../utils/helpers";
import { Form } from "react-bootstrap";

const SwitchRHF = (props: any) => {
  const { t } = useTranslation();

  const { register, formField, errors } = props;
  const label = getTranslatedLabel(formField.translations);

  return (
    <>
      <div className="dynamic-form-switch">
        <div className="d-flex align-items-center mt-2 form-check form-switch">
          <input
            {...register}
            type="checkbox"
            name={formField.name}
            className="form-check-input"
          />
          {props.label}
        </div>
      </div>

      {errors[formField.name] && (
        <div className="validation-errors-text-size text-danger mt-1 ms-2">
          {t("dynamic-form.required", { param: formField.name })}
        </div>
      )}
    </>
  );
};

export default SwitchRHF;
